import {
  FETCH_CURRENT_LOAD_DAY,
  SET_BID,
  SET_IS_SHOW_DIALOG_SAVE_NOMENCLATURE,
  SET_LOADING,
  SET_SELECTED_RESPONSE,
  UPDATE_STATUS_LOAD_DAY,
} from './actions/loadDay'
import Vue from 'vue'

import { RepositoryFactory } from '@/api/RepositoryFactory'
import deepMerge from '@/helpers/deepMerge'

const ResponsesAPI = RepositoryFactory.get('responses')
const LoadDayAPI = RepositoryFactory.get('loadDay')
const BidAPI = RepositoryFactory.get('bids')
const flag = true

export default {
  namespaced: true,
  state: {
    bid: {},
    currentLoadDay: {},
    loading: false,
    loadingResp: false,
    loadingRespRequest: false,
    responses: [],
    responsesInProgress: [],
    responsesStats: {},
    selectedResponse: [],
    isShowDialogSaveNomenclature: false,
    highlightResponseId: 0,
    highlightRequestId: 0,
  },
  getters: {
    getBid: state => state.bid,
    getCurrentLoadDay: state => state.currentLoadDay,
    getLoading: state => type => state[`loading${type || ''}`],
    getResponses: state => state.responses,
    getResponsesInProgress: state => state.responsesInProgress,
    getStats: state => field => state.responsesStats[field] || {},
    getSelected: state => state.selectedResponse,
    getIsShowDialogSaveNomenclature: state =>
      state.isShowDialogSaveNomenclature,
    getHighlightResponseId: state => state.highlightResponseId,
    getHighlightRequestId: state => state.highlightRequestId,
  },
  actions: {
    fetchBid: ({ commit }, { loadDayId, ...reqParams }) => {
      commit(SET_LOADING, { flag })
      BidAPI.getHomeBid(reqParams, false)
        .then(async res => {
          const bid = res.data.items[0] || {}

          await commit(SET_BID, bid)

          if (bid.id) {
            commit(FETCH_CURRENT_LOAD_DAY, loadDayId)
          }
        })
        .catch(e => console.log(e))
        .finally(() => commit(SET_LOADING))
    },
    fetchResponsesInDay({ commit }, requestData) {
      const type = 'Resp'

      commit(SET_LOADING, { flag, type })
      commit(SET_LOADING, { flag, type: 'RespRequest' })

      return ResponsesAPI.fetchResponsesInDay(requestData)
        .then(({ data }) => {
          if (data.responses_stats) {
            commit('setResponsesStats', data.responses_stats)
          }
          commit('setResponses', data.responses)
          commit('setResponsesInProgress', data.response_requests)
        })
        .catch(e => console.log(`[fetchResponsesInDay] err: `, e))
        .finally(() => {
          commit(SET_LOADING, { type })
          commit(SET_LOADING, { type: 'RespRequest' })
        })
    },
    fetchResponsesUpdate({ commit }, requestData) {
      const type = 'Resp'

      commit(SET_LOADING, { flag, type })

      return ResponsesAPI.fetchResponsesInDay(requestData)
        .then(({ data }) => {
          if (data.responses_stats) {
            commit('setResponsesStats', data.responses_stats)
          }
          commit('setResponses', data.responses)
        })
        .catch(e => console.log(`[fetchResponsesInDay] err: `, e))
        .finally(() => commit(SET_LOADING, { type }))
    },

    [SET_SELECTED_RESPONSE]: ({ commit }, payload) =>
      commit(SET_SELECTED_RESPONSE, payload),
    [SET_IS_SHOW_DIALOG_SAVE_NOMENCLATURE]: ({ commit }, payload) =>
      commit(SET_IS_SHOW_DIALOG_SAVE_NOMENCLATURE, payload),
    [UPDATE_STATUS_LOAD_DAY]: ({ commit }, payload) => {
      commit(SET_LOADING, { flag })
      let method = 'putLoadDay'

      if (payload?.status === 1) {
        method = 'closeLoadDay'
      }

      return LoadDayAPI[method](payload.id, { status: payload.status })
        .then(async ({ data }) => {
          await commit(UPDATE_STATUS_LOAD_DAY, data)

          if (data.id) {
            commit(FETCH_CURRENT_LOAD_DAY, data.id)
          }
        })
        .catch(e => console.log(e))
        .finally(() => commit(SET_LOADING))
    },
  },
  mutations: {
    [SET_SELECTED_RESPONSE]: (state, payload) =>
      (state.selectedResponse = payload),
    [SET_IS_SHOW_DIALOG_SAVE_NOMENCLATURE]: (state, payload) =>
      (state.isShowDialogSaveNomenclature = payload),
    [FETCH_CURRENT_LOAD_DAY]: (state, payload) =>
      (state.currentLoadDay =
        state.bid['load_days']?.filter(day => day.id === Number(payload))[0] ||
        {}),
    [SET_LOADING](state, obj = {}) {
      const { flag, type } = obj

      state[`loading${type || ''}`] = Boolean(flag)
    },
    [UPDATE_STATUS_LOAD_DAY]: (state, payload) => {
      state.bid['load_days'] = state.bid['load_days']?.map(item =>
        item.id === payload.id ? payload : item,
      )
    },
    [SET_BID]: (state, payload) => (state.bid = payload),
    updateBid(state, { data }) {
      if (data) {
        state.bid = { ...state.bid, ...data }
      }
    },
    setResponses(state, responses) {
      state.responses = responses
    },
    setResponsesInProgress(state, response_requests) {
      state.responsesInProgress = response_requests
    },
    updateResponsesInProgress(state, response_requests) {
      let findIndex = state.responsesInProgress.findIndex(
        item => item.id === response_requests.id,
      )

      if (findIndex > -1) {
        Vue.set(
          state.responsesInProgress,
          findIndex,
          deepMerge(state.responsesInProgress[findIndex], response_requests),
        )
      }
    },
    updateResponsesInProgressByInn(state, response_requests) {
      state.responsesInProgress.map((item, index) => {
        if (item.organization_inn === response_requests.inn) {
          Vue.set(
            state.responsesInProgress,
            index,
            deepMerge(state.responsesInProgress[index], {
              contragent_id: response_requests.id,
              contragent_name: response_requests.org_name,
              contragent_phone_match:
                response_requests.phone ===
                state.responsesInProgress[index].request_phone
                  ? 1
                  : 0,
              request_phone: response_requests.phone,
            }),
          )
        }
      })
    },
    updateResponsesInProgressByPhone(state, response_requests) {
      state.responsesInProgress.map((item, index) => {
        if (item.organization_inn === response_requests.inn) {
          Vue.set(
            state.responsesInProgress,
            index,
            deepMerge(state.responsesInProgress[index], {
              contragent_phone_match:
                response_requests.phone ===
                state.responsesInProgress[index].request_phone,
              request_phone: response_requests.phone,
            }),
          )
        }
      })
    },
    setResponsesStats(state, responsesStats) {
      state.responsesStats = responsesStats || {}
    },
    deleteResponse(state, id) {
      state.responses = state.responses.filter(d => d.id !== id)
    },
    setUpdateResponse(state, data) {
      const updated = state.responses.map(d => {
        if (Number(d.id) === Number(data.id)) {
          d = { ...d, ...data }
        }

        return d
      })

      state.responses = updated
    },
    setHighlightResponseId(state, id) {
      state.highlightResponseId = id
    },
    setHighlightRequestId(state, id) {
      state.highlightRequestId = id
    },
  },
}
